import type { CSSProperties } from 'react';
import { cn } from '../lib/utils';

export function CustomTable({
  data,
  className,
  style,
}: {
  data: {
    _key?: string;
    _type?: 'table';
    rows:
      | {
          cells: string[] | null;
        }[]
      | null;
  };
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      id="custom-table"
      className={cn('overflow-x-auto', className)}
      style={
        {
          '--table-color': 'var(--color-brand-burgundy)',
          ...style,
        } as CSSProperties
      }
    >
      <table className="w-full border border-[hsl(var(--table-color))]/30">
        <thead>
          <tr className="border-[hsl(var(--table-color))]/30 border-b">
            {data.rows?.[0]?.cells?.map((cell, i) => (
              <th
                key={`header-${cell}-${i}`}
                className={cn(
                  'p-4 text-left',
                  'text-[hsl(var(--table-color))]',
                  'border-[hsl(var(--table-color))]/30 border-r',
                  i === (data.rows?.[0]?.cells?.length ?? 0) - 1 && 'border-r-0'
                )}
              >
                {cell}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.rows?.slice(1).map((row, i) => (
            <tr
              key={i}
              className="border-[hsl(var(--table-color))]/30 border-b"
            >
              {row.cells?.map((cell, j) => (
                <td
                  key={`cell-${cell}-${i}`}
                  className={cn(
                    'p-4',
                    'text-[hsl(var(--table-color))]',
                    'border-[hsl(var(--table-color))]/30 border-r',
                    j === (row.cells?.length ?? 0) - 1 && 'border-r-0'
                  )}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
